import script from "./CompletionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionView.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionView.vue?vue&type=style&index=0&id=455ad0b3&lang=scss"

const __exports__ = script;

export default __exports__